import TopActionBlock from 'blocks/TopActionBlock';
import GenericErrorComponent from 'components/InfoBoxComponent/GenericErrorComponent';
import LoadingIndicatorComponent from 'components/LoadingIndicatorComponent';
import { HasAccessContext } from 'contexts/HasAccessContext';
import BackLink from 'domain/Links/BackLink';
import { useTeacherListWithoutGroupsQuery } from 'queries/textile_deals/useTeacherListQueries';
import React, { useContext, useEffect } from 'react';
import { HistoryProps } from 'utils/history';
import { textileOrderIdFromMatch } from 'utils/history/textile-order-id-from-match';
import { textileOrderRoute } from 'utils/history/textile-order-route';
import TeachersWithoutTextileGroup from './TeachersWithoutTextileGroup';

const TeachersWithoutTextileGroupsScreen: React.FC<HistoryProps> = (props) => {
  const textileOrderId = textileOrderIdFromMatch(props.match);
  const teacherList = useTeacherListWithoutGroupsQuery(textileOrderId);
  const accessContext = useContext(HasAccessContext);

  if (!accessContext) {
    throw Error('Component must be used within HasAccessContextProvider');
  }

  useEffect(() => {
    accessContext.checkSectionAccess('design');
  }, [accessContext]);

  const renderPage = (content: React.ReactNode) => {
    return (
      <>
        <TopActionBlock>
          <BackLink to={textileOrderRoute(props.match, '/groups')} />
        </TopActionBlock>

        {content}
      </>
    );
  };

  if (teacherList.isError) {
    return renderPage(
      <GenericErrorComponent onRetryClick={() => teacherList.refetch()} />
    );
  }

  if (teacherList.isLoading || !teacherList.data) {
    return renderPage(<LoadingIndicatorComponent />);
  }

  return (
    <TeachersWithoutTextileGroup
      teachers={teacherList.data}
      textileOrderId={textileOrderIdFromMatch(props.match)}
    />
  );
};

export default TeachersWithoutTextileGroupsScreen;
